


















































































































































































































































































import { Component, Vue, Prop } from "vue-property-decorator";
import Copy from "@/components/copy.vue";
import MainHeader from "../../../main/components/main-header/main-header.vue";
import NavLeft from "../../components/nav-left.vue";
import { GetHospitals, GetDownloadFile } from "@/request/hdr";
import {
  PostDataExport,
  GetTongueTemplates,
  GetTongueTopicsOfTemplate,
} from "@/request/tongue";
import SelectMultiSearch from "./select-multi-search.vue";
@Component({
  components: {
    Copy,
    MainHeader,
    NavLeft,
    SelectMultiSearch,
  },
})
export default class IdrDataExport extends Vue {
  private hospitals: any[] = [];
  private filters: any = {
    hospital_ids: [],
    开始时间: "",
    结束时间: "",
    时间段: "",
    条件: "全部条件",
    行研究指标: [],
    列研究指标: [],
    timeWay: "所有时间",
    time: [],
  };
  private ifAllHospital: any = false;
  private searchedTemplates: any[] = [];
  private zhibiaos: any[] = [
    { name: "定性特征参数", template_id: "定性特征参数" },
    { name: "颜色特征参数", template_id: "颜色特征参数" },
    { name: "几何特征参数", template_id: "几何特征参数" },
    { name: "纹理特征参数", template_id: "纹理特征参数" },
  ];

  /**
   * @description 获得可选医院列表
   */
  private fetchHospitals() {
    GetHospitals(this).then((data: any) => {
      this.hospitals = data;
    });
  }
  /**
   * @description 点选全部医院时
   */
  private allHospitalChange(value) {
    if (value) {
      this.filters.hospital_ids = [""];
    } else {
      this.filters.hospital_ids = [];
    }
  }
  /**
   * @description 添加研究指标变量
   */
  private addTiaojian() {
    this.filters["行研究指标"].push({ result: {}, selected: {} });
  }
  /**
   * @description 获取当前分组下的可选模板列表
   */
  private fetchTemplates() {
    GetTongueTemplates(this).then((data: any) => {
      this.searchedTemplates = data;
    });
  }
  /**
   * @description 搜索模板下具体的字段
   */
  private searchItems(l) {
    GetTongueTopicsOfTemplate(this, l.template_id).then((data: any) => {
      l.items = data;
      this.$forceUpdate();
    });
  }
  /**
   * @description 删除一个条件
   */
  private deleteTiaojian(index: any) {
    this.filters["行研究指标"].splice(index, 1);
  }
  /**
   * @description 全选
   */
  private selectAll() {
    this.filters["列研究指标"] = [];
    this.zhibiaos.forEach((item: any) => {
      this.filters["列研究指标"].push(item);
    });
  }
  /**
   * @description 清除
   */
  private removeAll() {
    this.filters["列研究指标"] = [];
  }

  /**
   * @description 导出
   */
  private startExport() {
    if (!this.filters["表格名称"]) {
      this.$message.warning("请填写数据表格名称");
      return;
    }
    if (this.filters.hospital_ids.length === 0) {
      this.$message.warning("请选择要导出的所属机构");
      return;
    }
    if (this.filters["列研究指标"].length === 0) {
      this.$message.warning("请至少选择一个舌图研究类型");
      return;
    }
    let hIds: any = this.filters["hospital_ids"];
    if (
      this.filters["hospital_ids"].length === 1 &&
      this.filters["hospital_ids"][0] === ""
    ) {
      hIds = [];
    }
    const loading = this.$loading({ text: "导出中..." });
    const params: any = {
      表格名称: this.filters["表格名称"],
      hospital_ids: hIds,
      时间段: this.filters["timeWay"],
      条件: this.filters["条件"],
      列研究指标: this.filters["列研究指标"],
    };
    // 时间段
    if (this.filters.timeWay === "自定义") {
      params["开始时间"] = this.filters.time[0];
      params["结束时间"] = this.filters.time[1];
    }
    if (this.filters["行研究指标"].length > 0) {
      const arr: any[] = [];
      this.filters["行研究指标"].map((item: any) => {
        const i = JSON.parse(JSON.stringify(item.selected));
        i.condition = item.result.condition;
        i.value = item.result.value;
        arr.push(i);
      });
      params["行研究指标"] = arr;
    }
    PostDataExport(this, params).then((data: any) => {
      this.$message.success("创建成功");
      loading.close();
      window.open(
        window.API_ROOT + "api/wajue/download?filename=" + data.file_name
      );
    });
  }
  /**
   * @description 初始化
   */
  private mounted() {
    this.fetchHospitals();
    this.fetchTemplates();
  }
}
